import '../styles/Gdpr.css';

function Gdpr() {
    const goHome = () => {
        window.location.href = '/';
    };

    return (
        <main className="gdpr-page">
            <article className="gdpr-article">
                <p className="gdpr-eyebrow">Integritet och trygghet</p>
                <h1>Så hanterar vi GDPR och personuppgifter</h1>
                <p className="gdpr-lede">
                    Vi värnar om din integritet. Därför följer vi Dataskyddsförordningen (GDPR) i varje steg
                    när vi samlar in, behandlar och lagrar personuppgifter i samband med våra redovisnings- och
                    rådgivningstjänster.
                </p>

                <section>
                    <h2>Vilka uppgifter samlar vi in?</h2>
                    <p>
                        När du kontaktar oss via formulär, e-post eller telefon tar vi endast emot uppgifter som är
                        nödvändiga för att återkoppla och erbjuda våra tjänster. Det kan vara namn, kontaktuppgifter,
                        företagsinformation och den fråga du har ställt.
                    </p>
                </section>

                <section>
                    <h2>Varför lagrar vi uppgifter?</h2>
                    <p>
                        Uppgifterna används för att svara på din förfrågan, genomföra rådgivning och fullfölja avtalade
                        tjänster. Vi sparar aldrig fler uppgifter än vad syftet kräver och vi delar aldrig information
                        med tredje part utan ditt uttryckliga samtycke eller ett lagkrav.
                    </p>
                </section>

                <section>
                    <h2>Hur länge sparas uppgifterna?</h2>
                    <p>
                        Personuppgifterna lagras endast så länge som de behövs för att uppfylla lagkrav eller de
                        tjänster vi utför åt dig. Därefter raderas eller anonymiseras informationen på ett säkert sätt.
                    </p>
                </section>

                <section>
                    <h2>Dina rättigheter</h2>
                    <p>
                        Du kan när som helst begära utdrag, rättelse eller radering av dina uppgifter. Kontakta oss via
                        kontaktformuläret eller på telefon så hjälper vi dig snabbt och transparent.
                    </p>
                </section>

                <section>
                    <h2>Kontakt vid frågor</h2>
                    <p>
                        Har du frågor om hur vi hanterar personuppgifter eller vill utöva någon av dina rättigheter?
                        Klick på knappen kontakta oss nedan eller ring oss direkt så svarar vi gärna på alla dina frågor och funderingar.
                    </p>
                </section>

                <div className="gdpr-cta">
                    <button onClick={goHome}>Tillbaka till startsidan</button>
                    <a href="/kontakt">Kontakta oss</a>
                </div>
            </article>
        </main>
    );
}

export default Gdpr;
